import React from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Col, Row } from 'react-bootstrap'

function WorkTimeInput({ className }) {

  const { workdays, setWorkdays, shifts, setShifts, shiftHours, setShiftHours } = ComponentData()

  return (
    <div className={className}>
      {/* Tage */}
      <Row>
        <Col md={4}>
          <div className="input-fields">
            <input type="number" value={workdays} onChange={(e) => {
              if (e.target.value >= 0) {
                setWorkdays(e.target.value)
              }
            }} />
            <span className='unit-label'>Arbeitstage</span>
          </div>
        </Col>
        {/* Schichten */}
        <Col md={4}>
          <div className="input-fields">
            <input type="number" value={shifts} onChange={(e) => {
              if (e.target.value >= 0) {
                setShifts(e.target.value)
              }
            }} />
            <span className='unit-label'>Schichten</span>
          </div>
        </Col>
        {/* Stunden/Schicht */}
        <Col md={4}>
          <div className="input-fields">
            <input type="number" value={shiftHours} onChange={(e) => {
              if (e.target.value >= 0) {
                setShiftHours(e.target.value)
              }
            }} />
            <span className='unit-label'>Stunden/Schicht</span>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default WorkTimeInput